"use client";

import { useEffect } from "react";

/**
 * Robust body scroll lock. Plain `overflow:hidden` on <body> is not
 * enough — it doesn't stop touch scrolling on mobile and can be
 * overridden once GSAP ScrollTrigger recalculates pin spacing.
 * Freezing the body at a fixed position guarantees the page behind
 * the modal cannot move no matter what other scroll logic is active.
 */
export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;

    const scrollY = window.scrollY;
    const { style } = document.body;

    style.position = "fixed";
    style.top = `-${scrollY}px`;
    style.left = "0";
    style.right = "0";
    style.width = "100%";

    return () => {
      style.position = "";
      style.top = "";
      style.left = "";
      style.right = "";
      style.width = "";
      window.scrollTo(0, scrollY);
    };
  }, [active]);
}